module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/design/circle-87783686fad65dff1c53dd7acc77e174.svg";